import '../../styles/Admin/BankDetails.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BankDetails = () => {
  const [bankDetails, setBankDetails] = useState([]);
  const [form, setForm] = useState({
    bankName: '',
    accountHolderName: '',
    accountNumber: '',
    ifscCode: '',
    branchName: '',
    contactNumber: ''
  });
  const [editMode, setEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    fetchBankDetails();
  }, []);

  const fetchBankDetails = async () => {
    try {
      const response = await axios.get('/api/bank-details');
      setBankDetails(response.data);
    } catch (error) {
      console.error('Error fetching bank details:', error);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        await axios.put(`/api/bank-details/${selectedId}`, form);
        setSuccess('Bank details updated successfully');
      } else {
        await axios.post('/api/bank-details', form);
        setSuccess('Bank details added successfully');
      }
      setForm({
        bankName: '',
        accountHolderName: '',
        accountNumber: '',
        ifscCode: '',
        branchName: '',
        contactNumber: ''
      });
      setEditMode(false);
      setSelectedId(null);
      fetchBankDetails();
    } catch (error) {
      setError('Error saving bank details');
      console.error('Error saving bank details:', error);
    }
  };

  const handleEdit = (id) => {
    console.log(`Edit clicked for ID: ${id}`);
    const detail = bankDetails.find(item => item._id === id);
    setForm(detail);
    setEditMode(true);
    setSelectedId(id);
  };

  const handleDelete = async (id) => {
    console.log(`Delete clicked for ID: ${id}`);
    try {
      await axios.delete(`/api/bank-details/${id}`);
      fetchBankDetails();
    } catch (error) {
      console.error('Error deleting bank detail:', error);
    }
  };

  return (
    <div className="bank-details">
      <h1>Bank Details</h1>
      {error && <div className="error">{error}</div>}
      {success && <div className="success">{success}</div>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="bankName"
          value={form.bankName}
          onChange={handleChange}
          placeholder="Bank Name"
          required
        />
        <input
          type="text"
          name="accountHolderName"
          value={form.accountHolderName}
          onChange={handleChange}
          placeholder="Account Holder Name"
          required
        />
        <input
          type="text"
          name="accountNumber"
          value={form.accountNumber}
          onChange={handleChange}
          placeholder="Account Number"
          required
        />
        <input
          type="text"
          name="ifscCode"
          value={form.ifscCode}
          onChange={handleChange}
          placeholder="IFSC Code"
          required
        />
        <input
          type="text"
          name="branchName"
          value={form.branchName}
          onChange={handleChange}
          placeholder="Branch Name"
          required
        />
        <input
          type="text"
          name="contactNumber"
          value={form.contactNumber}
          onChange={handleChange}
          placeholder="Contact Number"
          required
        />
        <button type="submit">{editMode ? 'Update' : 'Add'} Bank Details</button>
      </form>
      <div className="bank-details-list">
        {bankDetails.map(detail => (
          <div key={detail._id} className="bank-detail">
            <p>{detail.bankName}</p>
            <p>{detail.accountHolderName}</p>
            <p>{detail.accountNumber}</p>
            <p>{detail.ifscCode}</p>
            <p>{detail.branchName}</p>
            <p>{detail.contactNumber}</p>
            <button onClick={() => handleEdit(detail._id)}>Edit</button>
            <button onClick={() => handleDelete(detail._id)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankDetails;

